import { APP_PAGE_ID } from "../constants";

const getDisplayAdPlacement = (app, platform, placement) =>
  `${APP_PAGE_ID[app][platform.toLowerCase()]}-${placement}`;

export default getDisplayAdPlacement;
